<template>
  <div>
    <div class="text pause">
      <img src="@/assets/biomes/biome3/instructions.png">
      <h1>Le passage est dans le salut, la brique dans le son</h1>
      <p v-if="appVersion == 'web'">
        Utilisez <img class="keys-2" src="@/assets/images/arrows.png"> ou <img class="keys-2" src="@/assets/images/ZQSD.png"> pour vous déplacer,<br>
        <img class="keys-1" src="@/assets/images/entree.png"> ou <img class="keys-1" src="@/assets/images/space.png"> pour parler avec les autres,<br>
        <img class="keys-1" src="@/assets/images/p.png"> pour la pause.
      </p>
      <p v-else>
        Utilisez <img class="keys-1" src="@/assets/images/cross.png"> pour vous déplacer,<br>
        <img class="keys-1" src="@/assets/images/button_A.png"> ou <img class="keys-1" src="@/assets/images/button_B.png"> pour interagir avec les autres,<br>
        <img class="keys-1" src="@/assets/images/button_C.png"> pour la pause.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Biome3Fr',
  computed: {
    appVersion: () => process.env.VUE_APP_VERSION,
  }
}
</script>

<style scoped src="@/assets/css/menus.css" />
